import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Message18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_635)'>
      <path
        d='M6.99999 9C6.99999 9.55228 6.55228 10 5.99999 10C5.44771 10 4.99999 9.55228 4.99999 9C4.99999 8.44772 5.44771 8 5.99999 8C6.55228 8 6.99999 8.44772 6.99999 9Z'
        fill='currentColor'
      />
      <path
        d='M9.49999 10C10.0523 10 10.5 9.55228 10.5 9C10.5 8.44772 10.0523 8 9.49999 8C8.94771 8 8.49999 8.44772 8.49999 9C8.49999 9.55228 8.94771 10 9.49999 10Z'
        fill='currentColor'
      />
      <path
        d='M14 9C14 9.55228 13.5523 10 13 10C12.4477 10 12 9.55228 12 9C12 8.44772 12.4477 8 13 8C13.5523 8 14 8.44772 14 9Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.9419 1.50481C11.2272 0.717012 9.29401 0.539624 7.46429 1.00213C5.63456 1.46463 4.01846 2.53918 2.88518 4.0471C1.75189 5.55503 1.16988 7.40531 1.2362 9.28986C1.299 11.0741 1.93934 12.7868 3.05665 14.1732L0.574711 15.8822C-0.0176065 16.29 0.2809 17.2499 1.00005 17.2499H9.44623C11.3328 17.26 13.1661 16.6247 14.6411 15.4495C16.1167 14.2737 17.1447 12.6285 17.5538 10.7876C17.9629 8.94674 17.7282 7.02146 16.889 5.33241C16.0498 3.64338 14.6567 2.29262 12.9419 1.50481ZM7.83189 2.45639C9.32969 2.07778 10.9121 2.22302 12.3157 2.86785C13.7193 3.51267 14.8591 4.61809 15.5457 5.99986C16.2322 7.38162 16.4241 8.95646 16.0895 10.4623C15.7549 11.9681 14.9139 13.3141 13.7064 14.2763C12.4988 15.2385 10.9975 15.7586 9.45243 15.7499H3.41177L4.17573 15.2239C4.18291 15.2189 4.19001 15.2138 4.19701 15.2087C4.76599 14.7869 4.85091 13.9409 4.37715 13.4146C3.36875 12.2498 2.78943 10.7758 2.73528 9.2371C2.68102 7.69565 3.15706 6.18205 4.08429 4.94829C5.01154 3.71451 6.3341 2.83498 7.83189 2.45639Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_635'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Message18.displayName = 'Message18';
export default Message18;
